export default __webpack_public_path__ + "static/media/data_feed.0877b44b.svg";